import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

  private userRoles: any[] = [];
    constructor(private router: Router) {
      localStorage.removeItem('filter');
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      //console.log(route,state);
        if (localStorage.getItem('currentUser')) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page
        this.router.navigate(['/pages/login']);
        return false;
    }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      if(localStorage.getItem('currentUser')) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        let Osystem = 'setting';
        if(localStorage.getItem('OpenSystem')) {
           Osystem = localStorage.getItem('OpenSystem');
        }
        this.userRoles = userdata.roles.description;
        let urltxt =  state.url.replace(/^\//, '');
        let urlparts = urltxt.split('/');
        if(urlparts.length === 1) {
          if(this.userRoles.indexOf(Osystem+'.'+urlparts[0]+'.create') === -1 && this.userRoles.indexOf('setting.'+urlparts[0]+'.create') === -1) {
            this.router.navigate(['/'+urlparts[0]+'/list']);
            return false;
          }
        } else if(urlparts.length === 2) {

        } else if(urlparts.length === 3) {
          switch (urlparts[1]) {
            case 'edit':
              if(this.userRoles.indexOf(Osystem+'.'+urlparts[0]+'.update') === -1 && this.userRoles.indexOf('setting.'+urlparts[0]+'.update') === -1) {
                alert("Sorry, Don't have permission");
                return false;
              }
              break;

          }
        }
      }


    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts